import instance_api from "../../config/axiosConfig";
import {getOtSkills, getOvertimeCallsheet, addOTShiftAPI, resolveOTWbFailed } from "../../constants/constants";

class OvertimeAPI {
    
    constructor(name) {
        this.name = name;
    }

    getOTSkillsData(station='') {
        return instance_api("GET", getOtSkills(station));
    }
    
    getCallsheet({ otGroup='', schedBidGroup='', volOtDate='', station='', shiftsReqs=[] }) {
        const data = {
            otGroup,
            schedBidGroup,
            volOtDate,
            station,
            shiftsReqs
        };
        return instance_api('POST', getOvertimeCallsheet(), data);
    }

    addOTShift(data) {
        return instance_api('POST', addOTShiftAPI(), data);
    }

    resolveWbFailed(data) {
        return instance_api('POST', resolveOTWbFailed(), data);
    }
}

export const {
    getOTSkillsData,
    getCallsheet,
    addOTShift,
    resolveWbFailed
} = new OvertimeAPI("instance");
